export const getBillingNotice = (entitlements, now = new Date()) => {
  const dueDate = String(entitlements?.billingNextDueDate || '');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dueDate)) return null;

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(now);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const today = `${values.year}-${values.month}-${values.day}`;
  const toUtc = (value) => Date.UTC(...value.split('-').map((item, index) => Number(item) - (index === 1 ? 1 : 0)));
  const days = Math.round((toUtc(dueDate) - toUtc(today)) / 86400000);

  if (days === 2) return { severity: 'warning', message: 'O pagamento do seu sistema vence em 2 dias.' };
  if (days === 1) return { severity: 'warning', message: 'O pagamento do seu sistema vence em 1 dia.' };
  if (days === 0) return { severity: 'warning', message: 'O vencimento do seu sistema é hoje' };
  if (days < 0) return { severity: 'error', message: 'Seu sistema está em atraso!' };
  return null;
};
